import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FacilitiesList } from '@lt/components';
import { useTranslation } from '@lt/localization';

const StyledTitle = styled.div`
  ${({ theme }) => theme.typography.headline3}
  margin-bottom: 10px;
`;

const StyledFacilitiesList = styled(FacilitiesList)`
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  li {
    flex-basis: 49%;
  }

  li:nth-child(even) {
    margin-left: 1%;
  }
`;

const RoomFacilities = ({ items }) => {
  const { t } = useTranslation();
  return (
    <div>
      <StyledTitle>{t('hotel.facilities.hasRooms')}</StyledTitle>
      <StyledFacilitiesList items={items} showItemCheck />
    </div>
  );
};

RoomFacilities.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      best: PropTypes.bool,
    }).isRequired,
  ).isRequired,
};

export default RoomFacilities;
